import { ClientOnly } from "@/components/Base/ClientOnly";
import Icon from "@/components/Icon";
import { useNavigate } from "@solidjs/router";

export enum TitlePosition {
  LEFT = "left",
  CENTER = "center",
}
export default function PageNav(props: {
  close?: () => void;
  title: string;
  titlePosition?: TitlePosition;
}) {
  const navigate = useNavigate();
  return (
    <div class="bg-general-up-di sticky top-0 z-[1000] flex h-[48px] w-full items-center px-[12px]">
      <ClientOnly>
        <Icon
          name="general/arrow_left"
          class="text-general-white size-[12px]"
          wrapperClass="icon-square-button size-[28px] !rounded-[5px]"
          onClick={() => {
            if (props.close) {
              props.close();
            } else {
              navigate(-1);
            }
          }}
        />
      </ClientOnly>
      <h1
        class={`text-general-light max-w-[calc(100%-104px)] text-[16px] font-bold ${props.titlePosition == TitlePosition.LEFT ? "ml-[10px]" : "absolute left-1/2 translate-x-[-50%]"} w-[max-content]`}
      >
        {props.title}
      </h1>
    </div>
  );
}
